import Vue from 'vue'
import Vuex from 'vuex'
import appModule from './modules/app-module'
import utilityModule from './modules/utility-module'
import orderModule from './modules/order-module'
import imageModule from './modules/image-module'
import landingModule from './modules/landing-module'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,
  modules: {
    app: appModule,
    utility: utilityModule,
    order: orderModule,
    image: imageModule,
    landing: landingModule,
  }
})

export default store